import React from 'react';

export const GameInfoBlock = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  const contentElement = React.createElement(
    typeof children === 'string' ? 'p' : 'div',
    { className: 'GameInfoBlock__content' },
    children
  );
  return (
    <div className="GameInfoBlock">
      <h5 className="GameInfoBlock__header">{title}</h5>
      {contentElement}
    </div>
  );
};
